<template lang="pug">
VeeField(
  name="deliveryLocation"
  :validate-on-blur="false"
  v-slot="{ field, errors }")
  PlacesSearchRefined(
    ref="deliveryInput"
    v-bind="field"
    :model-value="getDeliveryAddress !== null ? getDeliveryAddress.place.formatted_address : ''"
    @focus="onFocus"
    @blur="onBlur"
    @place="setDeliveryPlace"
    :label="$t('location_form.moving_to')"
    :label-position="labelPosition"
    label-bg="white"
    :placeholder="labelPosition === 'animated' ? undefined : $t('location_form.town_or_postcode')"
    input-id="dropoff-location"
    :custom-classes="customClasses"
    qa-tag="inp-delivery-loc"
    :class="{ 'error': error }")
  VeeErrorMessage(name="deliveryLocation")
    TextInputErrorRefined.my-ds-sm(v-if="newErrorMessage")
      | {{ $t("location_form.error.moving_to") }}
    TextInputError.my-ds-sm(v-else)
      | {{ $t("location_form.error.moving_to") }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters, mapActions } from "vuex"
import { getAttributes } from "~/utils/block"
import {
  SET_DELIVERY_ADDRESS,
  SET_LISTING,
  GET_DELIVERY_ADDRESS,
  state as InitialListing,
  defaultAddress
} from "~/store/listing"
import { placeToAddress } from "~/scripts/convert"

export default defineComponent({
  name: "NewLocationDeliveryInput",

  props: {
    block: {
      type: Object as () => Record<string, any>,
      required: true
    },
    virgin: {
      type: Boolean
    },
    lazy: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: String,
      default: ""
    },
    error: {
      type: String
    },
    customClasses: {
      type: String,
      default: ""
    },
    labelPosition: {
      type: String,
      default: "border"
    },
    newErrorMessage: {
      type: Boolean,
      default: false
    }
  },
  emits: ["focus"],

  computed: {
    ...mapGetters("listing", {
      getDeliveryAddress: GET_DELIVERY_ADDRESS
    }),

    attributes(): Record<string, any> | null {
      return this.virgin ? null : this.getAttributes(this.block)
    }
  },

  created() {
    this.setListing(InitialListing())
  },

  methods: {
    ...mapActions("listing", {
      setDeliveryAddress: SET_DELIVERY_ADDRESS,
      setListing: SET_LISTING
    }),

    getAttributes,

    setDeliveryPlace(place: google.maps.places.PlaceResult | null): void {
      this.setDeliveryAddress(place !== null ? placeToAddress(place) : defaultAddress)

      // Trigger Snowplow events
      if (place && place.formatted_address) {
        // Fire the "selected" event
        this.$snowplow.trackEvent({
          category: "moving_to",
          action: "selected",
          property: place.formatted_address
        })
      }
    },

    focus() {
      this.$refs.deliveryInput.$el.querySelector("input").focus()
    },

    onFocus(): void {
      this.$emit("focus")
      this.$snowplow.trackEvent({
        category: "moving_to",
        action: "click"
      })
    },

    onBlur(): void {
      // Access the input element using the ref
      const inputElement = (
        this.$refs.deliveryInput as Vue & { $el: HTMLElement }
      )?.$el.querySelector("input") as HTMLInputElement

      if (!inputElement) {
        return
      }

      const inputValue = inputElement.value

      if (inputValue) {
        this.$snowplow.trackEvent({
          category: "moving_to",
          action: "entered",
          property: inputValue
        })
      }
    }
  }
})
</script>

<style lang="css" module></style>
